import { render, staticRenderFns } from "./AuthorLogin.vue?vue&type=template&id=69dd8256&scoped=true"
import script from "./AuthorLogin.vue?vue&type=script&lang=js"
export * from "./AuthorLogin.vue?vue&type=script&lang=js"
import style0 from "./AuthorLogin.vue?vue&type=style&index=0&id=69dd8256&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dd8256",
  null
  
)

export default component.exports